import { toPersistentStream } from '@ardoq/rxbeach';
import { type ContextSort, getDefaultSort } from '@ardoq/common-helpers';
import { getDefaultLocale, type Locale } from '@ardoq/locale';
import { combineLatest, map } from 'rxjs';
import { locale$ } from 'streams/locale$';
import { sort$ } from './sort$';

export type ComponentSort = {
  sort: ContextSort;
  locale: Locale;
};

const toComponentSort = ([sort, locale]: [
  ContextSort,
  Locale,
]): ComponentSort => ({ sort, locale });

export const componentSort$ = toPersistentStream<ComponentSort>(
  'componentSort$',
  combineLatest([sort$, locale$]).pipe(map(toComponentSort)),
  { sort: getDefaultSort(), locale: getDefaultLocale() }
);
